import TourExperienceScreen from '../(tabs)/tours/[experienceId]'
import { previewReserveCustomTour } from '../../preview/custom-tour-quote'
import { seedToursPreview } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewExperienceRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursPreview} seedKey="experience">
      <TourExperienceScreen reserveOverride={previewReserveCustomTour} />
    </PreviewSeedBoundary>
  )
}
